import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import languageLocale from 'utils/LanguageLocale';
import Accordion from 'components/ProductPage/Accordion/Accordion';
import Info from 'components/ProductPage/Info';
import RwdProductPageEN from 'components/ProductPage/locales/RwdProductPage_en_US.js';
import RwdProductPageFR from 'components/ProductPage/locales/RwdProductPage_fr_CA.js';

const getText = text => languageLocale.getLocalisedDataFromResource(RwdProductPageEN, RwdProductPageFR)(text);

function AboutTheProduct({
    content, productDetails, currentSku, currentProduct, isSmallView
}) {
    const hasDetailsData = productDetails && currentSku && currentProduct;

    return content ? (
        <Accordion
            title={getText('aboutTheProduct')}
            id='aboutTheProduct'
            dataAt='aboutTheProduct'
            isAboutProductSection={true}
        >
            {hasDetailsData && (
                <Info
                    isAboutProductSection={true}
                    currentSku={currentSku}
                    product={currentProduct}
                    isRegularProductSmallView={isSmallView}
                    description={productDetails.longDescription || currentProduct.longDescription}
                    dataAt='about_the_product_title'
                />
            )}
        </Accordion>
    ) : null;
}

export default wrapFunctionalComponent(AboutTheProduct, 'AboutTheProduct');
